import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { signal, inject, ElementRef, NgZone, DestroyRef, computed, Component, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { switchMap, filter, takeUntil, tap } from 'rxjs/operators';

/**
 *
 * @param event
 */
const _c0 = ["*"];
function isMouseEvent(event) {
  return event instanceof MouseEvent;
}
/**
 *
 * @param event
 */
function isWheelEvent(event) {
  return event instanceof WheelEvent;
}
let NgDocMagnifierComponent = /*#__PURE__*/(() => {
  class NgDocMagnifierComponent {
    constructor() {
      this.x = signal(0);
      this.y = signal(0);
      this.scale = signal(1);
      this.drag = signal(false);
      this.document = inject(DOCUMENT);
      this.element = inject(ElementRef).nativeElement;
      this.ngZone = inject(NgZone);
      this.destroyRef = inject(DestroyRef);
      this.transform = computed(() => {
        const scale = this.scale();
        const x = this.x();
        const y = this.y();
        return `matrix(${scale}, 0, 0, ${scale}, ${x * scale}, ${y * scale})`;
      });
    }
    ngOnInit() {
      fromEvent(this.element, 'mousedown').pipe(switchMap(event => {
        event.preventDefault();
        this.drag.set(true);
        return fromEvent(this.document, 'mousemove').pipe(filter(isMouseEvent), takeUntil(fromEvent(this.document, 'mouseup')), tap({
          complete: () => this.drag.set(false)
        }));
      }), takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        this.x.update(x => x + event.movementX / this.scale());
        this.y.update(y => y + event.movementY / this.scale());
      });
      fromEvent(this.element, 'wheel').pipe(filter(isWheelEvent), takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        event.preventDefault();
        this.scale.update(scale => Math.max(scale * (1 + event.deltaY / 1000), 1));
      });
    }
    incrementX(x) {
      this.x.update(current => current + x / this.scale());
    }
    incrementY(y) {
      this.y.update(current => current + y / this.scale());
    }
    zoom(diff) {
      this.scale.update(scale => Math.max(scale * (1 + diff / 1000), 1));
    }
    reset() {
      this.x.set(0);
      this.y.set(0);
      this.scale.set(1);
    }
    static {
      this.ɵfac = function NgDocMagnifierComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocMagnifierComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocMagnifierComponent,
        selectors: [["ng-doc-magnifier"]],
        hostVars: 1,
        hostBindings: function NgDocMagnifierComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-drag", ctx.drag());
          }
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 2,
        consts: [[1, "ng-doc-magnifier-container"]],
        template: function NgDocMagnifierComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("transform", ctx.transform());
          }
        },
        styles: ["[_nghost-%COMP%]{display:block;overflow:hidden;cursor:default}[data-drag=true][_nghost-%COMP%]{cursor:move}"],
        changeDetection: 0
      });
    }
  }
  return NgDocMagnifierComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocMagnifierComponent };
